import React, { useEffect, useRef } from 'react'
import { Input, List, Modal } from 'antd'
import 'src/Common/ChatApp.scss'
import 'src/Pages/LibraryPages/librarypages.scss'
import Sidebar from './ChatSidebar'
import ChatWindow from './ChatWindow'
import useCounselorChat from './useCounselorChat'
import useSignalRPresence from 'src/Hooks/CounselorHooks/SingleR/useSignalRPresence'
import { useLocation } from 'react-router-dom'

const ChatIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
    <path d="M8 9h8M8 12.5h5" />
  </svg>
)

const StartChat = () => {
  const { unreadMessages } = useSignalRPresence()
  const {
    handleFileUpload,
    hubConnection,
    userId,
    token,
    students,
    groupChat,
    groups,
    tutors,
    counselors,
    activeChats,
    isModalVisible,
    loading,
    mentorModelVisible,
    isGroupModalVisible,
    isTutorModalVisible,
    chatMessages,
    chatDetails,
    startChat,
    startGroupChat,
    sendMessage,
    hoveredId,
    setHoveredId,
    search,
    setSearch,
    modelSearch,
    setModelSearch,
    setIsModalVisible,
    setMentorModelVisible,
    setIsGroupModalVisible,
    setIsTutorModalVisible,
    setSelectedChatId,
    selectedChatId,
    fetchChatDetails,
    setChatDetails,
    setChatMessages,
    loader,
    conversations,
    fetchConversations,
    msgLoader,
    role,
    startMentorGroupChat,
    loadOlderMessages,
    hasMoreMessages,
    loadingOlder,
  } = useCounselorChat()

  const location = useLocation()
  useEffect(() => {
    if (location.state?.selectedChatId) {
      setSelectedChatId(location.state.selectedChatId)
    }
  }, [location.state])

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <ChatIcon />
          </span>
          <div>
            <h1 className="lpg__title">Messaging</h1>
            <p className="lpg__sub">Chat with students, parents, tutors and groups.</p>
          </div>
        </div>
      </div>
      <div className="chat-container">
        <Sidebar
          activeChats={activeChats}
          search={search}
          setSearch={setSearch}
          setIsModalVisible={setIsModalVisible}
          setIsGroupModalVisible={setIsGroupModalVisible}
          setIsTutorModalVisible={setIsTutorModalVisible}
          setMentorModelVisible={setMentorModelVisible}
          setSelectedChatId={setSelectedChatId}
          selectedChatId={selectedChatId}
          hoveredId={hoveredId}
          setHoveredId={setHoveredId}
          userId={userId}
          token={token}
          loader={loader}
          conversations={conversations}
          fetchConversations={fetchConversations}
          unreadMessages={unreadMessages}
        />

        <div className="chat-section">
          {selectedChatId ? (
            <>
              <ChatWindow
                handleFileUpload={handleFileUpload}
                setSelectedChatId={setSelectedChatId}
                hubConnection={hubConnection}
                selectedChatId={selectedChatId}
                sendMessage={sendMessage}
                userId={Number(userId)}
                token={token}
                fetchChatDetails={fetchChatDetails}
                chatDetails={chatDetails}
                chatMessages={chatMessages || []}
                setChatDetails={setChatDetails}
                setChatMessages={setChatMessages}
                loading={loading}
                msgLoader={msgLoader}
                conversations={conversations}
                loadOlderMessages={loadOlderMessages}
                hasMoreMessages={hasMoreMessages}
                loadingOlder={loadingOlder}
              />
            </>
          ) : (
            <div className="chat-header2">Click New Chat / Group Chat to start a conversation</div>
          )}
        </div>

        <Modal
          title={role === 'Parent' || role === 'Tutor' ? 'Select a Counselor' : 'Select a Student'}
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: '10px' }}
          />

          {/* Parent & Tutor -> Counselors list show */}
          {role === 'Parent' ? (
            <List
              bordered
              dataSource={counselors.filter((counselor) =>
                counselor.name.toLowerCase().includes(modelSearch.toLowerCase()),
              )}
              renderItem={(counselor) => (
                <List.Item onClick={() => startChat(counselor)} style={{ cursor: 'pointer' }}>
                  {counselor.name}
                </List.Item>
              )}
            />
          ) : (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <List
                bordered
                dataSource={students.filter((student) =>
                  student.name.toLowerCase().includes(modelSearch.toLowerCase()),
                )}
                renderItem={(student) => (
                  <List.Item
                    onClick={() => {
                      console.log('Selected student:', student)
                      startChat(student)
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {student.name}
                  </List.Item>
                )}
              />
            </div>
          )}
        </Modal>

        <Modal
          title="Select a Tutor"
          open={isTutorModalVisible}
          onCancel={() => setIsTutorModalVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <List
              bordered
              dataSource={tutors.filter((tutor) =>
                tutor.name.toLowerCase().includes(modelSearch.toLowerCase()),
              )}
              renderItem={(tutor) => (
                <List.Item onClick={() => startChat(tutor)} style={{ cursor: 'pointer' }}>
                  {tutor.name}
                </List.Item>
              )}
            />
          </div>
        </Modal>

        <Modal
          title="Select Students to create a group"
          open={mentorModelVisible}
          onCancel={() => setMentorModelVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <List
              bordered
              dataSource={groups.filter((mentorGroup) =>
                mentorGroup.groupName.toLowerCase().includes(modelSearch.toLowerCase()),
              )}
              renderItem={(mentorGroup) => (
                <List.Item
                  onClick={() => {
                    startMentorGroupChat(mentorGroup)
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {mentorGroup.groupName}
                </List.Item>
              )}
            />
          </div>
        </Modal>

        <Modal
          title="Select Students and Parents for Group Chat"
          open={isGroupModalVisible}
          onCancel={() => setIsGroupModalVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <List
              bordered
              dataSource={groupChat.filter((group) =>
                group.name.toLowerCase().includes(modelSearch.toLowerCase()),
              )}
              renderItem={(student) => (
                <List.Item onClick={() => startGroupChat(student)} style={{ cursor: 'pointer' }}>
                  {role === 'Parent' && student.counselorName
                    ? `${student.name} (Counselor: ${student.counselorName})`
                    : student.name}
                </List.Item>
              )}
            />
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default StartChat
